import { createRouter, createWebHistory } from 'vue-router'
import { authSession, saveReturnTo } from '@/auth/session'
import AppLayout from '@/components/layout/AppLayout.vue'
import { resolveChatContext } from '@/runtime/chatContext'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/views/AuthCallbackView.vue'),
    },
    {
      path: '/embed/:botName',
      component: AppLayout,
      meta: { authGate: true, authSurface: 'embedded' },
      children: [
        {
          path: '',
          name: 'embed-chat',
          component: () => import('@/views/EmbedChatView.vue'),
          meta: { authSurface: 'embedded' },
        },
      ],
    },
    {
      path: '/',
      component: AppLayout,
      meta: { authGate: true, authSurface: 'full' },
      children: [
        {
          path: '',
          name: 'landing',
          component: () => import('@/views/LandingView.vue'),
        },
        {
          path: 'bots/:botName',
          name: 'bot-name',
          component: () => import('@/views/ChatView.vue'),
        },
        {
          path: 'bots/:botId/:botSlug?/sessions/:sessionId?',
          name: 'bot-session',
          component: () => import('@/views/ChatView.vue'),
        },
      ],
    },
  ],
})

router.beforeEach((to) => {
  if (to.name === 'login' || to.name === 'auth-callback') {
    return true
  }

  if (!to.matched.some(record => record.meta.authGate)) {
    return true
  }

  const botName = typeof to.params.botName === 'string' ? to.params.botName : null
  const sessionId = typeof to.params.sessionId === 'string' ? to.params.sessionId : null

  if (sessionId && !authSession.isAuthenticated) {
    saveReturnTo(to.fullPath)
    return {
      name: 'login',
      query: { reason: 'auth_required' },
    }
  }

  const context = resolveChatContext({ botId: botName })
  if (context.access !== 'requires_auth') {
    return true
  }

  if (to.matched.some(record => record.meta.authSurface === 'embedded')) {
    return true
  }

  saveReturnTo(to.fullPath)
  return {
    name: 'login',
    query: { reason: 'auth_required' },
  }
})

export default router
